module.exports = __webpack_public_path__ + "img/logo.a0f2dab4.png";